<nb-card class="dialog-modal-card {{size}}">
    <nb-card-header>{{ title }}</nb-card-header>
    <nb-card-body>
        <div [innerHTML]="body"></div>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton status="success" (click)="dismiss('YES')">{{btnAccept}}</button>
        <button nbButton status="danger" (click)="dismiss('NO')">{{btnCancel}}</button>
    </nb-card-footer>
</nb-card>